import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';

export type VhChipTone = 'neutral' | 'brand' | 'accent' | 'info';

/**
 * Small removable chip. Used for active-filter summaries.
 */
@Component({
  selector: 'vh-chip',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"vh-chip vh-chip--" + tone()',
  },
  template: `
    <span class="vh-chip__label"><ng-content /></span>
    @if (removable()) {
      <button
        type="button"
        class="vh-chip__remove"
        [attr.aria-label]="removeLabel()"
        (click)="removed.emit()"
      >
        <vh-icon name="x" size="sm" />
      </button>
    }
  `,
  styleUrl: './chip.component.scss',
})
export class VhChipComponent {
  readonly tone = input<VhChipTone>('neutral');
  readonly removable = input(true, { transform: booleanAttribute });
  readonly removeLabel = input<string>('Remove filter');

  readonly removed = output<void>();
}
